import styled, { css, keyframes } from 'styled-components';

const dropableCss = ({ canDrop }) =>
  canDrop &&
  css`
    box-shadow: 0px 0 0 4px var(--primary300);
  `;

const loadingKeyframes = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

const loadingKeyframesRules = css`
  ${loadingKeyframes} 1.5s infinite;
`;

const loadingEffect = ({ loading }) =>
  loading &&
  css`
    opacity: 0.8;
    transition: opacity ease-out 0.6s;
    overflow: hidden;
    .show-on-hover {
      display: none !important;
    }
    &:after {
      display: block;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      transform: translateX(-100%);
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.1), transparent);
      animation: ${loadingKeyframesRules};
    }
  `;

const cardWrapperVerticalStyles = ({ vertical }) =>
  vertical &&
  css`
    padding: 0;
  `;

const cardVerticalStyles = ({ vertical }) =>
  vertical &&
  css`
    margin: ${({ theme }) => theme.base.gridSizes.S};
    margin-top: 0;
  `;

export const StyledCardWrapper = styled.div`
  background: ${({ theme, backgroundSkin }) =>
    theme.base.colorSchema[backgroundSkin] || 'transparent'};
  padding: ${({ theme }) => theme.base.gridSizes.S} 0;
  display: flex;
  ${cardWrapperVerticalStyles}
`;

export default styled.div`
  background-color: var(--grey100);
  margin: 0 ${({ theme }) => theme.base.gridSizes.S} 0 0;
  ${({ isFirst }) =>
    isFirst &&
    css`
      margin-left: ${({ theme }) => theme.base.gridSizes.S};
    `}

  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);

  display: flex;
  flex-direction: column;

  width: 350px;

  color: var(--grey800);

  transition: opacity ease-in 0.1s;

  ${dropableCss}
  ${loadingEffect}

  .show-on-hover {
    display: none;
  }

  &:hover .show-on-hover {
    display: block;
  }

  ${cardVerticalStyles}
`;
